import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2570c783"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "become-a-member-wrapper--desktop"
}
const _hoisted_2 = { class: "become-a-member-card--desktop" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "We want you in the ANGIE Community!", -1))
const _hoisted_4 = {
  key: 1,
  class: "become-a-member-wrapper--mobile"
}
const _hoisted_5 = { class: "become-a-member-card--mobile" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-4" }, "We want you in the ANGIE Community!", -1))


import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'BecomeAMemberSection',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const router = useRouter();

const props = __props;

const goToBecomeAMember = () => {
  router.push("/partners#becoming-a-member");
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_v_btn, {
              class: "become-a-member-btn--dektop",
              onClick: goToBecomeAMember
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Become a member! ")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_v_btn, {
              class: "become-a-member-btn--mobile",
              onClick: goToBecomeAMember
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Become a member! ")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})